import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ScrollingModule} from '@angular/cdk/scrolling';

import {CatalogManagerComponent} from './catalog-manager.component';
import {SectionTreeComponent} from './section-tree/section-tree.component';
import {ItemListComponent} from './item-list/item-list.component';
import {ItemDetailsComponent} from './item-details/item-details.component';
import {SectionBoxComponent} from './section-box/section-box.component';
import {GlobalModule} from "../../../../global-module/global-module.module";
import {AdminGlobalModule} from "../../../admin-global-module.module";

@NgModule({
    declarations: [
        CatalogManagerComponent,
        SectionTreeComponent,
        ItemListComponent,
        ItemDetailsComponent,
        SectionBoxComponent
    ],
    imports: [
        AdminGlobalModule,
        CommonModule,
        FormsModule,
        IonicModule,
        ScrollingModule
    ],
    exports: [
        CatalogManagerComponent
    ]
})
export class CatalogManagerModule {
}
